import React from 'react';

import Tab from './tab/tab';

import './tabs.scss';

interface TabsProps {
  className?: string;
  isSecondary?: boolean;
}

function Tabs(props: React.PropsWithChildren<TabsProps>) {
  const { children, className = '', isSecondary } = props;

  const childrenArray = React.Children.toArray(children);

  if (!childrenArray?.length) return null;

  return (
    <div className={`tabs ${className}`} role="tablist" styleName="container">
      {childrenArray.map(child => {
        if (React.isValidElement(child)) {
          return React.cloneElement(child as React.ReactElement, {
            ...child.props,
            isSecondary: isSecondary
          });
        }
      })}
    </div>
  );
}

export { Tab };
export default Tabs;
